export default __webpack_public_path__ + "static/media/kalayana.6501be75.png";